(function () {
  if (window.__f4dCartBtnInit) return;
  window.__f4dCartBtnInit = true;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.f4d-cart-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.classList.contains('f4d-cart-btn--loading') || btn.classList.contains('f4d-cart-btn--added')) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('f4d-cart-btn--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: 'f4d-native-cart-drawer' })
    })
      .then(function (res) { return res.json(); })
      .then(function (result) {
        btn.classList.remove('f4d-cart-btn--loading');
        btn.classList.add('f4d-cart-btn--added');

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count], .cart-count, .cart__count, [aria-label*="cart"] .count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: result,
            sourceId: variantId,
            data: {
              source: 'f4d-product-card',
              sections: result.sections
            }
          }
        }));

        setTimeout(function () {
          btn.classList.remove('f4d-cart-btn--added');
        }, 2000);
      })
      .catch(function () {
        btn.classList.remove('f4d-cart-btn--loading');
      });
  });
})();
